import Vue from 'vue'
import Vuex from 'vuex'

import { Loading,  QSpinnerFacebook,  } from 'quasar'
import { Notify } from 'quasar'


var URL = 'https://server-erida.konaweselatankab.go.id/';
// var URL = 'http://localhost:5070/';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    coordinat : {
      lat:-4.034694, 
      lng: 122.484263
    },
    btn : {
      add : false,
      edit : false,
      remove : false,
    },
    url : {
      URL_APP : URL,
      URL_Beranda : URL + 'api/v1/server_beranda/',
      URL_VerifikasiPenelitian : URL + 'api/v1/server_verifikasi_penelitian/',
      URL_VerifikasiUsulan : URL + 'api/v1/server_verifikasi/',
      URL_VerifikasiSida : URL + 'api/v1/server_verifikasi_sida/',
      URL_Profil : URL + 'api/v1/server_profil/',
      URL_Panduan : URL + 'api/v1/server_panduan/',
      URL_Berita : URL + 'api/v1/web_berita/',
      URL_Usulan : URL + 'api/v1/server_usulan/',
      URL_Penelitian : URL + 'api/v1/server_penelitian/',
      URL_Sida : URL + 'api/v1/server_sida/',
      URL_Artikel : URL + 'api/v1/server_artikel/',
      URL_Pengguna : URL + 'api/v1/server_pengguna/',
      // URL_Kategori : URL + 'api/v1/web_publish_kategori/',
      // URL_Level : URL + 'api/v1/web_publish_kelompok/',
      URL_Tahun : URL + 'api/v1/server_tahun/',
      URL_Foto : URL + 'api/v1/server_foto/',
      URL_Video : URL + 'api/v1/server_video/',
      URL_Riset : URL + 'api/v1/server_riset/',
      URL_Perubahan : URL + 'api/v1/server_perubahan/',
      URL_Teknologi : URL + 'api/v1/server_teknologi/',
      URL_Iid : URL + 'api/v1/server_iid/',
      URL_Ipkd : URL + 'api/v1/server_ipkd/',
      URL_Idsd : URL + 'api/v1/server_idsd/',
      URL_Haki : URL + 'api/v1/server_haki/',
      URL_Ikm : URL + 'api/v1/server_ikm/',
      URL_IKMM : URL + 'api/v1/web_publish_ikm/',
      URL_Tim : URL + 'api/v1/server_tim/',
      URL_Krenova : URL + 'api/v1/server_krenova/',
      URL_Tema : URL + 'api/v1/server_tema/',
      URL_Dokumen : URL + 'api/v1/server_dokumen/',
    
    },





    unit_kerja : '',

    page_first: 1,
    page_last: 0,
    cari_value: "",
    cek_load_data : true,

    
  },
  mutations: {

    getStorage(state){
      var get_profile = JSON.parse(localStorage.profile);
      state.unit_kerja = get_profile.profile.unit_kerja; 
    },
    shoWLoading(){
      const spinner = typeof QSpinnerFacebook !== 'undefined'
        ? QSpinnerFacebook // Non-UMD, imported above
        : Quasar.components.QSpinnerFacebook // eslint-disable-line


      Loading.show({
        spinner,
        spinnerColor: 'red',
        spinnerSize: 140,
        backgroundColor: 'purple',
        // message: 'Loading... Tunggu beberapa saat, system sedang menyesuaikan akun anda..!',
        // messageColor: 'white'
      })
    },
    hideLoading(){
      Loading.hide()
    },
    shoWNotify(state, message, color, icon){
      Notify.create({
        message: message,
        color: color,
        position : 'top-right',
        icon:icon
      })
    },
  },
  actions: {
  },
  modules: {
  }
})
